module.exports = __webpack_public_path__ + "static/media/fallbackProfilePicture.4ef62125.svg";